import { IOfferCard } from '../../../../types';
import { isFromBuilder, isFromSeller, isFromLeadFactory } from '../../utils';

export const prepareTitle = (offerCard: IOfferCard): string => {
  const { isByHomeowner, offerUser } = offerCard;

  const fromBuilder = isFromBuilder(offerCard);
  const fromSeller = isFromSeller(offerCard);
  const fromLeadFactory = isFromLeadFactory(offerCard);

  switch (true) {
    case isByHomeowner:
      return 'Собственник';

    case !fromLeadFactory && fromBuilder:
      return 'Застройщик';

    case !fromLeadFactory && !fromBuilder && fromSeller:
      return 'Представитель застройщика';

    case fromLeadFactory:
      return 'Консультант';

    case offerUser?.masterAgent || offerUser?.accountType === 'agency':
      return 'Агентство недвижимости';

    case offerUser?.accountType === 'rentDepartment':
      return 'Отдел аренды';

    case offerUser?.accountType === 'specialist':
      return 'Риелтор';

    case offerUser?.accountType === 'managementCompany':
      return 'Ук・оф.Представитель';

    case !!offerUser?.bank:
      return 'Банк';

    default:
      return '';
  }
};
